import React from 'react';

/**
 * states: prev_step_not_done -> ready -> done
 */
export const ob_card_states = {
  ready: 'ready',
  prev_step_not_done: 'prev_step_not_done',
  done: 'done',
};

export const onboardign_card_keys = {
  create_categories: 'create_categories',
  upload_products: 'upload_products',
  choose_a_design: 'select_a_design',
  config_payment_method: 'config_payment_method',
  choose_delivery_method: 'choose_delivery_method',
};

export const onboarding_cards_actions = {
  set_card_done: 'set_card_done',
  set_initial: 'set_initial',
  set_categories_done: 'set_categories_done',
  set_products_done: 'set_products_done',
  set_design_done: 'set_design_done',
  set_payment_done: 'set_payment_done',
  set_delivery_done: 'set_delivery_done',
};

export const initial_onboarding_cards = [
  {
    step_number: 1,
    key: onboardign_card_keys.create_categories,
    title: '1. Crear categorías',
    image: (
      <svg
        width="30"
        height="28"
        viewBox="0 0 30 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M30 12.5V0.5H19.5V5H10.5V0.5H0V12.5H10.5V8H13.5V23H19.5V27.5H30V15.5H19.5V20H16.5V8H19.5V12.5H30Z"
          fill="#383838"
        />
      </svg>
    ),
    step_state: ob_card_states.ready,
    prev_card_key: null,
    link_to: '/categorias',
    amplitude_event: 'empretienda_onboarding_selecciona_categorias',
  },
  {
    step_number: 2,
    key: onboardign_card_keys.upload_products,
    title: '2. Subir productos',
    image: (
      <svg
        width="34"
        height="29"
        viewBox="0 0 34 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M24.815 10.4998L18.245 0.659785C17.96 0.239785 17.48 0.0297852 17 0.0297852C16.52 0.0297852 16.04 0.239785 15.755 0.674785L9.185 10.4998H2C1.175 10.4998 0.5 11.1748 0.5 11.9998C0.5 12.1348 0.515 12.2698 0.56 12.4048L4.37 26.3098C4.715 27.5698 5.87 28.4998 7.25 28.4998H26.75C28.13 28.4998 29.285 27.5698 29.645 26.3098L33.455 12.4048L33.5 11.9998C33.5 11.1748 32.825 10.4998 32 10.4998H24.815ZM12.5 10.4998L17 3.89979L21.5 10.4998H12.5ZM17 22.4998C15.35 22.4998 14 21.1498 14 19.4998C14 17.8498 15.35 16.4998 17 16.4998C18.65 16.4998 20 17.8498 20 19.4998C20 21.1498 18.65 22.4998 17 22.4998Z"
          fill="#383838"
        />
      </svg>
    ),
    step_state: ob_card_states.ready,
    prev_card_key: onboardign_card_keys.create_categories,
    link_to: '/productos/agregar',
    amplitude_event: 'empretienda_onboarding_selecciona_productos',
  },
  {
    step_number: 3,
    key: onboardign_card_keys.choose_a_design,
    title: '3. Cargar el logo de la tienda',
    image: (
      <svg
        width="30"
        height="28"
        viewBox="0 0 30 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.1001 16.9998C5.6101 16.9998 3.6001 19.0098 3.6001 21.4998C3.6001 23.4648 1.8601 24.4998 0.600098 24.4998C1.9801 26.3298 4.3351 27.4998 6.6001 27.4998C9.9151 27.4998 12.6001 24.8148 12.6001 21.4998C12.6001 19.0098 10.5901 16.9998 8.1001 16.9998ZM28.6651 2.94484L26.6551 0.934844C26.0701 0.349844 25.1251 0.349844 24.5401 0.934844L11.1001 14.3748L15.2251 18.4998L28.6651 5.05984C29.2501 4.47484 29.2501 3.52984 28.6651 2.94484Z"
          fill="#383838"
        />
      </svg>
    ),
    step_state: ob_card_states.ready,
    prev_card_key: onboardign_card_keys.upload_products,
    link_to: '/builder',
    amplitude_event: 'empretienda_onboarding_selecciona_diseño',
  },
  {
    step_number: 4,
    key: onboardign_card_keys.config_payment_method,
    title: '4. Configurar los métodos de pago',
    image: (
      <svg
        width="34"
        height="24"
        viewBox="0 0 34 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.94971 24C2.32471 24 1.79346 23.7812 1.35596 23.3438C0.918457 22.9062 0.699707 22.375 0.699707 21.75V4.5H2.94971V21.75H29.1997V24H2.94971ZM7.44971 19.5C6.82471 19.5 6.29346 19.2812 5.85596 18.8438C5.41846 18.4062 5.19971 17.875 5.19971 17.25V2.25C5.19971 1.625 5.41846 1.09375 5.85596 0.65625C6.29346 0.21875 6.82471 0 7.44971 0H31.4497C32.0747 0 32.606 0.21875 33.0435 0.65625C33.481 1.09375 33.6997 1.625 33.6997 2.25V17.25C33.6997 17.875 33.481 18.4062 33.0435 18.8438C32.606 19.2812 32.0747 19.5 31.4497 19.5H7.44971ZM7.44971 17.25H11.1997C11.1997 16.2 10.8372 15.3125 10.1122 14.5875C9.38721 13.8625 8.49971 13.5 7.44971 13.5V17.25ZM27.6997 17.25H31.4497V13.5C30.3997 13.5 29.5122 13.8625 28.7872 14.5875C28.0622 15.3125 27.6997 16.2 27.6997 17.25ZM19.4497 14.25C20.6997 14.25 21.7622 13.8125 22.6372 12.9375C23.5122 12.0625 23.9497 11 23.9497 9.75C23.9497 8.5 23.5122 7.4375 22.6372 6.5625C21.7622 5.6875 20.6997 5.25 19.4497 5.25C18.1997 5.25 17.1372 5.6875 16.2622 6.5625C15.3872 7.4375 14.9497 8.5 14.9497 9.75C14.9497 11 15.3872 12.0625 16.2622 12.9375C17.1372 13.8125 18.1997 14.25 19.4497 14.25ZM7.44971 6C8.49971 6 9.38721 5.6375 10.1122 4.9125C10.8372 4.1875 11.1997 3.3 11.1997 2.25H7.44971V6ZM31.4497 6V2.25H27.6997C27.6997 3.3 28.0622 4.1875 28.7872 4.9125C29.5122 5.6375 30.3997 6 31.4497 6Z"
          fill="#383838"
        />
      </svg>
    ),
    step_state: ob_card_states.ready,
    prev_card_key: onboardign_card_keys.choose_a_design,
    link_to: '/metodos-pago',
    amplitude_event: 'empretienda_onboarding_selecciona_metodos_de_pago',
  },
  {
    step_number: 5,
    key: onboardign_card_keys.choose_delivery_method,
    title: '5. Elegir los métodos de envío',
    image: (
      <svg
        width="34"
        height="24"
        viewBox="0 0 34 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.99961 23.9625C5.77461 23.9625 4.73086 23.5375 3.86836 22.6875C3.00586 21.8375 2.57461 20.7875 2.57461 19.5375H0.0996094V2.25C0.0996094 1.65 0.324609 1.125 0.774609 0.675C1.22461 0.225 1.74961 0 2.34961 0H24.0621V6.2625H27.9996L33.0996 13.05V19.5375H30.4371C30.4371 20.7875 30.0059 21.8375 29.1434 22.6875C28.2809 23.5375 27.2371 23.9625 26.0121 23.9625C24.7871 23.9625 23.7434 23.5375 22.8809 22.6875C22.0184 21.8375 21.5871 20.7875 21.5871 19.5375H11.4246C11.4246 20.7875 10.9934 21.8375 10.1309 22.6875C9.26836 23.5375 8.22461 23.9625 6.99961 23.9625ZM6.99961 21.7125C7.59961 21.7125 8.11211 21.5 8.53711 21.075C8.96211 20.65 9.17461 20.1375 9.17461 19.5375C9.17461 18.9375 8.96211 18.425 8.53711 18C8.11211 17.575 7.59961 17.3625 6.99961 17.3625C6.39961 17.3625 5.88711 17.575 5.46211 18C5.03711 18.425 4.82461 18.9375 4.82461 19.5375C4.82461 20.1375 5.03711 20.65 5.46211 21.075C5.88711 21.5 6.39961 21.7125 6.99961 21.7125ZM26.0121 21.7125C26.6121 21.7125 27.1246 21.5 27.5496 21.075C27.9746 20.65 28.1871 20.1375 28.1871 19.5375C28.1871 18.9375 27.9746 18.425 27.5496 18C27.1246 17.575 26.6121 17.3625 26.0121 17.3625C25.4121 17.3625 24.8996 17.575 24.4746 18C24.0496 18.425 23.8371 18.9375 23.8371 19.5375C23.8371 20.1375 24.0496 20.65 24.4746 21.075C24.8996 21.5 25.4121 21.7125 26.0121 21.7125ZM24.0621 14.0625H31.0371L26.8746 8.5125H24.0621V14.0625Z"
          fill="#383838"
        />
      </svg>
    ),
    step_state: ob_card_states.ready,
    prev_card_key: onboardign_card_keys.config_payment_method,
    link_to: '/metodos-envio',
    amplitude_event: 'empretienda_onboarding_selecciona_metodos_de_envio',
  },
];

/**
 * @summary: Recibe un array ordenado con la lista de estados
 * a asignar a todas las cards
 */
const onboarding_cards_change_state = (onboarding_cards, card_states) => {
  const new_onboarding_cards = [...onboarding_cards];

  card_states.map(
    (_step, index) =>
      (new_onboarding_cards[index].step_state = card_states[index])
  );

  return new_onboarding_cards;
};

/**
 * @summary: Recibe el estado y una key de card a pasar a estado done
 * @property {any} state
 * @property {onboardign_card_keys} payload
 */
const onboarding_card_set_done = (onboarding_cards, payload) => {
  const new_onboarding_cards = [...Array.from(onboarding_cards)];
  const card = new_onboarding_cards.find((card) => card.key === payload);
  card.step_state = ob_card_states.done;
  return new_onboarding_cards;
};

export const onboardingCardReducer = (state, action) => {
  const idCountry = state[0].idCountry || 'ARG';

  const ready = ob_card_states.ready;
  const prev_not_done = ob_card_states.prev_step_not_done;
  const done = ob_card_states.done;

  let cardStates = [];

  switch (action.type) {
    case onboarding_cards_actions.set_card_done: {
      const nextState = onboarding_card_set_done(state, action.payload);
      return nextState;
    }
    case onboarding_cards_actions.set_initial: {
      cardStates = [ready, ready, ready, ready, ready];

      idCountry === 'COL' && cardStates.pop();

      const nextState = onboarding_cards_change_state(state, cardStates);
      return nextState;
    }

    case onboarding_cards_actions.set_categories_done:
      cardStates = [done, ready, prev_not_done, prev_not_done, prev_not_done];

      idCountry === 'COL' && cardStates.pop();

      return onboarding_cards_change_state(state, cardStates);

    case onboarding_cards_actions.set_products_done:
      cardStates = [done, done, ready, prev_not_done, prev_not_done];

      idCountry === 'COL' && cardStates.pop();

      return onboarding_cards_change_state(state, cardStates);

    case onboarding_cards_actions.set_design_done:
      cardStates = [done, done, done, ready, prev_not_done];

      idCountry === 'COL' && cardStates.pop();

      return onboarding_cards_change_state(state, cardStates);

    case onboarding_cards_actions.set_payment_done:
      cardStates = [done, done, done, done, ready];

      idCountry === 'COL' && cardStates.pop();

      return onboarding_cards_change_state(state, cardStates);

    case onboarding_cards_actions.set_delivery_done:
      cardStates = [done, done, done, done, done];

      idCountry === 'COL' && cardStates.pop();

      return onboarding_cards_change_state(state, cardStates);

    default:
      return state;
  }
};

export const onboarding_handlers = {
  handleSetInitial: (dispatch) => {
    dispatch({ type: onboarding_cards_actions.set_initial });
  },
  handleSetCategoriesDone: (dispatch) => {
    dispatch({ type: onboarding_cards_actions.set_categories_done });
  },
  handleSetProductsDone: (dispatch) => {
    dispatch({ type: onboarding_cards_actions.set_products_done });
  },
  handleSetDesignDone: (dispatch) => {
    dispatch({ type: onboarding_cards_actions.set_design_done });
  },
  handleSetPaymentDone: (dispatch) => {
    dispatch({ type: onboarding_cards_actions.set_payment_done });
  },
  handleSetDeliveryDone: (dispatch) => {
    dispatch({ type: onboarding_cards_actions.set_delivery_done });
  },

  /**
   * @property {any} dispatch
   * @property {onboardign_card_keys} payload
   */
  handleSetCardDone: (dispatch, payload) => {
    dispatch({
      type: onboarding_cards_actions.set_card_done,
      payload,
    });
  },
};
